import { getHttpClient } from './httpClient';

export interface Seed {
  id: string;
  name: string;
  slug: string;
  description: string;
  lang: string;
  hasUnseed: boolean;
  loaded: boolean;
  locked: boolean;
  unregistered: boolean;
  loadedLang: string | null;
}

export async function listSeeds(): Promise<Seed[]> {
  return (await getHttpClient().get<Seed[]>('/api/admin/seeds')).data;
}

export async function executeSeed(id: string): Promise<{ message: string }> {
  return (await getHttpClient().post(`/api/admin/seeds/${id}/execute`)).data;
}

export async function registerSeed(id: string): Promise<{ message: string }> {
  return (await getHttpClient().post(`/api/admin/seeds/${id}/register`)).data;
}

export async function rollbackSeed(id: string): Promise<{ message: string }> {
  return (await getHttpClient().post(`/api/admin/seeds/${id}/rollback`)).data;
}
